<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<!--  Баблы внутренних табов  -->
<div class="bubble-container head">
    <button [class.selected]="tab === 0"
            (click)="tab = 0"
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.MAIN' | translate }}
    </button>
    <button [class.selected]="tab === 1"
            (click)="tab = 1"
            disabled
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.STATISTICS' | translate }}
    </button>
    <button [class.selected]="tab === 2"
            (click)="tab = 2"
            disabled
    >
        {{ 'INDEX_PAGE.BUBBLES_TEXT.HISTORY' | translate }}
    </button>
</div>


@switch (tab) {
    @case (0) {
        <div class="table-container">

            <!--    Статистика по всем задачам    -->
            <div class="widget-container column-4 rows-2">
                @if (statisticData) {
                    <div class="widget-header">
                        <h2>{{ 'INDEX_PAGE.TASKS.WIDGET_HEADERS.STATISTICS' | translate }}</h2>
                        <i class="ri-refresh-line"
                           (click)="getStatistic()"
                        ></i>
                    </div>
                    <div class="widget-body tasks-statistic">
                        <div>
                            <span>{{ 'INDEX_PAGE.TASKS.TEXT.NORMAL' | translate }}</span>
                            <div class="circle-container">
                                <span>
                                    {{ statisticData.normal }}
                                </span>
                            </div>
                        </div>

                        <div>
                            <span>{{ 'INDEX_PAGE.TASKS.TEXT.MIDDLE' | translate }}</span>
                            <div class="circle-container">
                                <span>
                                    {{ statisticData.middle }}
                                </span>
                            </div>
                        </div>

                        <div>
                            <span>{{ 'INDEX_PAGE.TASKS.TEXT.IMPORTANT' | translate }}</span>
                            <div class="circle-container">
                                <span>
                                    {{ statisticData.important }}
                                </span>
                            </div>
                        </div>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>

            <!--  Статика предложения продуктов банка  -->
            <div class="widget-container column-2">
                <div class="widget-header">
                    <h2><i class="ri-arrow-right-up-box-fill"
                           style="color: #2563EB;"></i> Bank Operation</h2>
                </div>
            </div>
            <div class="widget-container column-2">
                <div class="widget-header">
                    <h2><i class="ri-arrow-right-up-box-fill"
                           style="color: #2563EB;"></i> Bank Function</h2>
                </div>
            </div>
            <div class="widget-container column-2">
                <div class="widget-header">
                    <h2><i class="ri-arrow-right-up-box-fill"
                           style="color: #2563EB;"></i> Bank Product</h2>
                </div>
            </div>
            <!--     Кнопки END       -->

            <!--  Рекламное предложение  -->
            <div class="widget-container column-6">
                <div class="widget-body row-ads">
                    <div>
                        <div style="display: flex; align-items: center;">
                            <span>{{ 'INDEX_PAGE.TASKS.TEXT.ADS.TITLE' | translate }}</span>
                            <span class="big">3 950 000 ₽</span>
                        </div>
                        <small class="light">{{ 'INDEX_PAGE.TASKS.TEXT.ADS.DAY' | translate }}</small>
                        <div class="main-ads">
                            <div style="margin-right: 30px;">
                                <span>240 220 ₽</span><br>
                                <small class="light">{{ 'INDEX_PAGE.TASKS.TEXT.ADS.PAY' | translate }}</small>
                            </div>
                            <div class="middle">
                                <span>{{ 'INDEX_PAGE.TASKS.TEXT.ADS.PERCENT' | translate }}</span><br>
                                <small class="light">{{ 'INDEX_PAGE.TASKS.TEXT.ADS.RATE' | translate }}</small>
                            </div>
                            <div style="margin-left: 30px;">
                                <span>0%</span><br>
                                <small class="light">{{ 'INDEX_PAGE.TASKS.TEXT.ADS.COMMISSION' | translate }}</small>
                            </div>
                        </div>
                    </div>

                    <div>
                        <button class="button blue"><i class="ri-wallet-2-fill"></i>
                            {{ 'INDEX_PAGE.TASKS.TEXT.ADS.SEND' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <!--  Таблица задач  -->
            <div class="widget-container column-5">
                @if (allTasksTable) {
                    <div class="widget-header">
                        <h2>
                            {{ 'INDEX_PAGE.TASKS.WIDGET_HEADERS.CONTRACTS' | translate }}
                        </h2>
                        <i class="ri-refresh-line"
                           (click)="changePage(1, true)"
                        ></i>

                    </div>
                    <div class="widget-body">
                        <div class="scroll-container">
                            @if (scrollContainer.scrollLeft !== 0) {
                                <div class="left-scroll"
                                     (click)="scrollBlock('left', scrollContainer)"
                                >
                                    <i class="ri-arrow-left-line"></i>
                                </div>
                            }

                            <div class="bubble-container"
                                 #scrollContainer
                            >
                                <button [class.selected]="tableTab === 'my'"
                                        (click)="changeTab('my')"
                                >
                                    <span>{{ 'INDEX_PAGE.TASKS.TEXT.MY_TASKS' | translate }}</span>
                                </button>
                                @for (board of allBoards; track board.alias) {
                                    <button [class.selected]="tableTab === board.alias"
                                            (click)="changeTab(board.alias)"
                                    >
                                        <span>{{ board.name }}</span>
                                    </button>
                                }
                            </div>

                            @if (scrollContainer.scrollWidth - 5 > (scrollContainer.scrollLeft + scrollContainer.offsetWidth)) {
                                <div class="right-scroll"
                                     (click)="scrollBlock('right', scrollContainer)"
                                >
                                    <i class="ri-arrow-right-line"></i>
                                </div>
                            }
                        </div>

                        <div class="tasks-table">
                            @for (task of allTasksTable[tableTab].tasks[allTasksTable[tableTab].pagination.current_page];
                                track task.task_alias) {
                                <div class="task-item"
                                     (click)="goTo(task)"
                                >
                                    <div class="header">
                                        <i class="ri-time-line"></i>
                                        {{ task.created_at | date:'dd.MM.yy HH:mm' }}

                                        @if (task.deadline_at) {
                                            <i class="ri-alarm-line"
                                               style="margin-left: 5px;"
                                            ></i>
                                            {{ task.deadline_at | date:'dd.MM.yy' }}
                                        }
                                    </div>
                                    <div class="body">{{ task.title }}</div>
                                </div>
                            } @empty {
                                <div>{{ 'EMPTY_LISTS.TASKS' | translate }}</div>
                            }
                            <app-component-pagination
                                    [pagination]="allTasksTable[tableTab].pagination"
                                    [totalPages]="allTasksTable[tableTab].pagination.pages"
                                    (page)="changePage($event)"
                            ></app-component-pagination>
                        </div>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>

            <!--  Календарь  -->
            <div class="widget-container column-5">
                @if (allTasksForCalendar) {
                    <div class="widget-header">
                        <h2>{{ 'INDEX_PAGE.TASKS.WIDGET_HEADERS.CALENDAR' | translate }}</h2>
                        <i class="ri-refresh-line"
                           (click)="getAllMyTasks(true)"
                        ></i>
                    </div>
                    <div class="widget-body calendar-widget">
                        <app-calendar
                                [monthDate]="today"
                                [items]="itemsMap"
                                [calendarLegend]="calendarLegend"
                                [maxItemsPerCell]="3"
                                (monthChange)="onAddItems($event[0], $event[1])"
                                (dayClick)="onDayClick($event)"
                                (itemClick)="onItemClick($event)"
                        >
                        </app-calendar>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>
        </div>
    }
    @case (1) {
        Тут статистика
    }
    @case (2) {
        тут история
    }
}
